(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  document.querySelectorAll('[data-ideal-footer-signup]').forEach((root) => {
    if (root.dataset.idealFooterSignupReady === 'true') return;
    root.dataset.idealFooterSignupReady = 'true';

    const form = root.querySelector('form');
    const emailChannel = root.querySelector('[data-ideal-signup-email-channel]');
    const viberChannel = root.querySelector('[data-ideal-signup-viber-channel]');
    const emailInput = root.querySelector('[data-ideal-signup-email]');
    const phoneInput = root.querySelector('[data-ideal-signup-phone]');
    const tagsInput = root.querySelector('[data-ideal-signup-tags]');
    const noteInput = root.querySelector('[data-ideal-signup-note]');
    const submitButton = root.querySelector('[data-ideal-signup-submit]');
    const message = root.querySelector('[data-ideal-signup-message]');

    if (!form || !emailInput || !phoneInput || !tagsInput || !noteInput || !submitButton || !message) return;

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const showMessage = (text, type = '') => {
      message.textContent = text;
      message.hidden = !text;
      message.classList.toggle('ideal-footer-signup__message--success', type === 'success');
      message.classList.toggle('ideal-footer-signup__message--error', type === 'error');
    };

    const isEmailValid = () => emailPattern.test(emailInput.value.trim());
    const isPhoneValid = () => phoneInput.value.replace(/\D/g, '').length >= 6;

    const setLoading = (isLoading) => {
      root.classList.toggle('ideal-footer-signup--loading', isLoading);
      root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      submitButton.classList.toggle('is-loading', isLoading);
      submitButton.disabled = isLoading || !canSubmit();
    };

    const canSubmit = () => {
      const wantsEmail = !emailChannel || emailChannel.checked;
      const wantsViber = Boolean(viberChannel && viberChannel.checked);
      if (!wantsEmail && !wantsViber) return false;
      if (wantsEmail && !isEmailValid()) return false;
      if (wantsViber && !isPhoneValid()) return false;
      return true;
    };

    const syncFields = () => {
      const wantsViber = Boolean(viberChannel && viberChannel.checked);
      phoneInput.required = wantsViber;
      emailInput.required = !emailChannel || emailChannel.checked;
      submitButton.disabled = !canSubmit();
    };

    const updatePayload = () => {
      const tags = ['newsletter', 'footer_signup', 'klaviyo_ready'];

      if (!emailChannel || emailChannel.checked) tags.push('email_optin');
      if (viberChannel && viberChannel.checked) tags.push('viber_optin');

      tagsInput.value = tags.join(',');

      const normalizedPhone = phoneInput.value.trim();
      noteInput.value = viberChannel && viberChannel.checked && normalizedPhone
        ? `Viber opt-in: +387 ${normalizedPhone}`
        : '';
    };

    emailChannel && emailChannel.addEventListener('change', syncFields);
    viberChannel && viberChannel.addEventListener('change', syncFields);
    emailInput.addEventListener('input', () => {
      emailInput.setCustomValidity('');
      showMessage('');
      syncFields();
    });
    phoneInput.addEventListener('input', () => {
      showMessage('');
      syncFields();
    });

    emailInput.addEventListener('invalid', () => {
      emailInput.setCustomValidity('Unesi ispravnu email adresu.');
    });

    const normalizePhone = () => {
      let digits = phoneInput.value.replace(/\D/g, '');
      if (digits.startsWith('387')) digits = digits.slice(3);
      if (digits.startsWith('0')) digits = digits.slice(1);
      return digits ? `+387${digits}` : '';
    };

    const saveKlaviyoProfile = async ({ wantsEmail, wantsViber }) => {
      const attributes = {
        locale: 'bs-BA',
        properties: {
          signup_source: 'ideal.ba footer',
          footer_signup: true,
          email_optin: wantsEmail,
          viber_optin: wantsViber,
          viber_optin_at: wantsViber ? new Date().toISOString() : null
        }
      };

      if (wantsEmail) attributes.email = emailInput.value.trim();
      if (wantsViber) attributes.phone_number = normalizePhone();

      const response = await fetch('https://a.klaviyo.com/client/profiles?company_id=YiBDBk', {
        method: 'POST',
        headers: {
          'Accept': 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          'revision': '2026-04-15'
        },
        body: JSON.stringify({
          data: {
            type: 'profile',
            attributes
          }
        })
      });

      if (!response.ok) throw new Error(`Klaviyo profile request failed: ${response.status}`);
    };

    const subscribeEmailInKlaviyo = async () => {
      const listId = root.dataset.klaviyoListId;
      if (!listId) throw new Error('Klaviyo list ID is missing');

      const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=YiBDBk', {
        method: 'POST',
        headers: {
          'Accept': 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          'revision': '2026-07-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'ideal.ba footer',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: emailInput.value.trim(),
                    locale: 'bs-BA',
                    properties: {
                      signup_source: 'ideal.ba footer',
                      footer_signup: true,
                      email_optin: true
                    },
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        })
      });

      if (!response.ok) throw new Error(`Klaviyo subscription request failed: ${response.status}`);
    };

    form.addEventListener('submit', async (event) => {
      const wantsEmail = !emailChannel || emailChannel.checked;
      const wantsViber = Boolean(viberChannel && viberChannel.checked);

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      syncFields();

      if (!canSubmit()) {
        const wantsEmail = !emailChannel || emailChannel.checked;
        const wantsViber = Boolean(viberChannel && viberChannel.checked);

        if (wantsEmail && !isEmailValid()) {
          emailInput.setCustomValidity('Unesi ispravnu email adresu.');
          emailInput.reportValidity();
        } else if (wantsViber && !isPhoneValid()) {
          showMessage('Unesi ispravan broj telefona za Viber obavje\u0161tenja.', 'error');
        } else {
          showMessage('Odaberi email ili Viber obavje\u0161tenja.', 'error');
        }
        return;
      }

      updatePayload();
      setLoading(true);
      showMessage('');

      try {
        if (wantsEmail) {
          await subscribeEmailInKlaviyo();
        }

        if (wantsViber) {
          await saveKlaviyoProfile({ wantsEmail, wantsViber });
        }

        form.reset();
        emailChannel && (emailChannel.checked = true);
        viberChannel && (viberChannel.checked = false);
        emailInput.setCustomValidity('');
        showMessage(wantsEmail
          ? 'Hvala! Uspje\u0161no si prijavljen/a za obavje\u0161tenja.'
          : 'Hvala! Broj je sa\u010duvan za Viber obavje\u0161tenja.', 'success');
      } catch (error) {
        console.error('Footer signup failed', error);
        showMessage('Prijavu trenutno nije mogu\u0107e sa\u010duvati. Poku\u0161aj ponovo za nekoliko trenutaka.', 'error');
      } finally {
        setLoading(false);
        syncFields();
      }
    }, true);

    syncFields();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    function initIdealDesktopMenu() {
      document.querySelectorAll('[data-ideal-desktop-menu]').forEach(function(menu) {
        if (menu.dataset.initialized) return;
        menu.dataset.initialized = 'true';

        var title = menu.querySelector('[data-ideal-desktop-title]');
        var back = menu.querySelector('[data-ideal-desktop-back]');
        var prev = menu.querySelector('[data-ideal-desktop-prev]');
        var next = menu.querySelector('[data-ideal-desktop-next]');
        var tabs = Array.from(document.querySelectorAll('[data-ideal-desktop-tab]'));
        var panels = Array.from(menu.querySelectorAll('[data-ideal-desktop-panel]'));
        var subpanels = Array.from(menu.querySelectorAll('[data-ideal-desktop-subpanel]'));
        var currentTab = tabs[0] ? tabs[0].dataset.idealDesktopTab : 'products';
        var currentSubpanel = null;
        var panelHistory = [];
        var currentPagePath = window.location.pathname.replace(/\/$/, '');
        var isProductPage = currentPagePath.indexOf('/products/') !== -1;
        var shouldShowInlineMenu = !isProductPage;
        var lastDesktopMenuMode = '';
        var lastHeaderHeight = 0;
        var desktopModeFrame = null;

        function placeDesktopMenu() {
          var headerSection = menu.closest('.shopify-section-group-header-group, .cc-header');
          if (headerSection && headerSection.parentNode && headerSection.nextSibling !== menu) {
            headerSection.parentNode.insertBefore(menu, headerSection.nextSibling);
          }
        }

        function getHeaderHeight() {
          var headerSection = document.querySelector('.shopify-section-group-header-group.cc-header, .cc-header');
          var storeHeader = document.querySelector('store-header');
          var source = headerSection || storeHeader;
          if (!source) return 0;
          return Math.max(0, Math.round(source.getBoundingClientRect().bottom));
        }

        function setDesktopMenuMode() {
          var headerHeight = getHeaderHeight();
          if (isProductPage) {
            if (headerHeight !== lastHeaderHeight) {
              document.documentElement.style.setProperty('--ideal-sticky-header-height', headerHeight + 'px');
              lastHeaderHeight = headerHeight;
            }
            menu.classList.remove('is-inline', 'is-flow');
            menu.classList.add('is-dropdown');
            if (menu.dataset.dropdownOpened) {
              menu.classList.add('is-open');
            } else {
              menu.classList.remove('is-open');
            }
            lastDesktopMenuMode = 'dropdown';
            return;
          }
          var menuRect = menu.getBoundingClientRect();
          var atPageTop = window.scrollY < 4;
          var shouldInline = shouldShowInlineMenu && (!menu.dataset.dropdownOpened || atPageTop);
          var shouldFlow = !shouldShowInlineMenu && menu.dataset.dropdownOpened && !menu.classList.contains('is-dropdown') && menuRect.bottom > headerHeight + 12;
          if (!menu.dataset.dropdownOpened && !shouldShowInlineMenu) {
            shouldFlow = atPageTop;
          }
          var nextMode = shouldInline ? 'inline' : shouldFlow ? 'flow' : 'dropdown';
          if (headerHeight !== lastHeaderHeight) {
            document.documentElement.style.setProperty('--ideal-sticky-header-height', headerHeight + 'px');
            lastHeaderHeight = headerHeight;
          }
          if (nextMode !== lastDesktopMenuMode) {
            menu.classList.toggle('is-inline', shouldInline);
            menu.classList.toggle('is-flow', shouldFlow);
            menu.classList.toggle('is-dropdown', !shouldInline && !shouldFlow);
            if (shouldInline) {
              menu.classList.add('is-open');
            } else if (shouldFlow && menu.dataset.dropdownOpened) {
              menu.classList.add('is-open');
            } else if (!menu.dataset.dropdownOpened) {
              menu.classList.remove('is-open');
            }
            lastDesktopMenuMode = nextMode;
          }
          updateScrollButtons();
        }

        function scheduleDesktopMenuMode() {
          if (desktopModeFrame) return;
          desktopModeFrame = window.requestAnimationFrame(function() {
            desktopModeFrame = null;
            setDesktopMenuMode();
          });
        }

        function openDesktopDropdown() {
          menu.dataset.dropdownOpened = 'true';
          if (isProductPage) {
            menu.classList.remove('is-inline', 'is-flow');
            menu.classList.add('is-dropdown');
          }
          menu.classList.add('is-open');
          setDesktopMenuMode();
          window.requestAnimationFrame(updateScrollButtons);
        }

        function closeDesktopDropdown() {
          delete menu.dataset.dropdownOpened;
          if (menu.classList.contains('is-dropdown') || menu.classList.contains('is-flow')) {
            menu.classList.remove('is-open');
          }
        }

        function getActiveList() {
          var activePanel = menu.querySelector('.ideal-desktop-menu__panel.is-active');
          return activePanel ? activePanel.querySelector('.ideal-desktop-menu__list') : null;
        }

        function updateScrollButtons() {
          var activeList = getActiveList();
          if (!activeList) {
            menu.dataset.canPrev = 'false';
            menu.dataset.canNext = 'false';
            return;
          }
          var maxScroll = activeList.scrollWidth - activeList.clientWidth;
          menu.dataset.canPrev = activeList.scrollLeft > 2 ? 'true' : 'false';
          menu.dataset.canNext = maxScroll - activeList.scrollLeft > 2 ? 'true' : 'false';
        }

        function syncActiveList() {
          subpanels.concat(panels).forEach(function(panel) {
            var list = panel.querySelector('.ideal-desktop-menu__list');
            if (!list || list.dataset.desktopScrollBound) return;
            list.dataset.desktopScrollBound = 'true';
            list.addEventListener('scroll', updateScrollButtons, { passive: true });
          });
          window.requestAnimationFrame(updateScrollButtons);
        }

        function getActiveTabLabel() {
          var activeTab = tabs.find(function(tab) {
            return tab.dataset.idealDesktopTab === currentTab;
          });
          return activeTab ? activeTab.textContent.trim() : 'Nazad';
        }

        function setBackLabel(label) {
          if (!back) return;
          back.dataset.label = label || 'Nazad';
          var backText = back.querySelector('span');
          if (backText) backText.dataset.label = label || 'Nazad';
        }

        function normalizePath(url) {
          if (!url) return '';
          var link = document.createElement('a');
          link.href = url;
          return link.pathname.replace(/\/$/, '') || '/';
        }

        function collectionHandleFromUrl(url) {
          var path = normalizePath(url);
          var match = path.match(/^\/collections\/([^\/?#]+)/);
          return match ? decodeURIComponent(match[1]) : '';
        }

        function getCardUrl(card) {
          return card ? (card.dataset.url || card.getAttribute('href') || '') : '';
        }

        function getCardDepth(card) {
          var subpanel = card ? card.closest('[data-ideal-desktop-subpanel]') : null;
          if (!subpanel) return 0;
          return (subpanel.dataset.idealDesktopSubpanel || '').split('-').length;
        }

        function isFinalCard(card) {
          return card && card.tagName === 'A' && !card.dataset.idealDesktopSubmenu;
        }

        function pickBestDesktopCard(cards) {
          return cards.sort(function(a, b) {
            var finalDiff = (isFinalCard(b) ? 1 : 0) - (isFinalCard(a) ? 1 : 0);
            if (finalDiff) return finalDiff;
            return getCardDepth(b) - getCardDepth(a);
          })[0] || null;
        }

        function findDesktopCardForCurrentUrl(currentPath, currentCollectionHandle) {
          var cards = Array.from(menu.querySelectorAll('.ideal-desktop-menu__card[data-url]'));
          var matches = cards.filter(function(card) {
            return normalizePath(getCardUrl(card)) === currentPath;
          });

          if (!matches.length && currentCollectionHandle) {
            matches = cards.filter(function(card) {
              return collectionHandleFromUrl(getCardUrl(card)) === currentCollectionHandle;
            });
          }

          return pickBestDesktopCard(matches);
        }

        function getTabLabel(tabKey) {
          var tab = tabs.find(function(tabButton) {
            return tabButton.dataset.idealDesktopTab === tabKey;
          });
          return tab ? tab.textContent.trim() : 'Nazad';
        }

        function getSubpanelTitle(id) {
          var panel = subpanels.find(function(subpanel) {
            return subpanel.dataset.idealDesktopSubpanel === id;
          });
          return panel ? panel.dataset.title || '' : '';
        }

        function setCurrentCard(card) {
          menu.querySelectorAll('.ideal-desktop-menu__card.is-current').forEach(function(currentCard) {
            currentCard.classList.remove('is-current');
          });
          if (card) card.classList.add('is-current');
        }

        function showTab(tabKey) {
          currentTab = tabKey;
          currentSubpanel = null;
          menu.classList.remove('is-submenu');
          if (back) {
            back.removeAttribute('data-label');
            var backText = back.querySelector('span');
            if (backText) backText.removeAttribute('data-label');
          }
          tabs.forEach(function(tab) {
            tab.classList.toggle('is-active', tab.dataset.idealDesktopTab === tabKey);
          });
          panels.forEach(function(panel) {
            var active = panel.dataset.idealDesktopPanel === tabKey;
            panel.classList.toggle('is-active', active);
            if (active && title) title.textContent = panel.dataset.title || '';
          });
          subpanels.forEach(function(panel) {
            panel.classList.remove('is-active');
          });
          syncActiveList();
        }

        function showSubpanel(id, panelTitle) {
          panels.forEach(function(panel) {
            panel.classList.remove('is-active');
          });
          subpanels.forEach(function(panel) {
            panel.classList.toggle('is-active', panel.dataset.idealDesktopSubpanel === id);
          });
          if (title) title.textContent = panelTitle || '';
          menu.classList.add('is-submenu');
          syncActiveList();
        }

        function activateTab(tabKey) {
          panelHistory = [];
          showTab(tabKey);
        }

        function activateSubmenu(id, panelTitle) {
          var previousLabel = currentSubpanel ? (title ? title.textContent : '') : getActiveTabLabel();
          panelHistory.push({
            tab: currentTab,
            subpanel: currentSubpanel,
            title: title ? title.textContent : '',
            label: previousLabel
          });
          currentSubpanel = id;
          setBackLabel(previousLabel);
          showSubpanel(id, panelTitle);
        }

        function restoreFromCurrentUrl() {
          if (isProductPage) return false;

          var currentPath = normalizePath(window.location.href);
          if (!currentPath || currentPath === '/') return false;
          var currentCollectionHandle = collectionHandleFromUrl(window.location.href);

          var matchedCard = findDesktopCardForCurrentUrl(currentPath, currentCollectionHandle);
          if (!matchedCard) return false;

          setCurrentCard(matchedCard);

          var targetSubmenu = matchedCard.dataset.idealDesktopSubmenu;
          if (targetSubmenu) {
            var targetParts = targetSubmenu.split('-');
            currentTab = targetParts[0] || currentTab;
            panelHistory = [];

            if (targetParts.length > 2) {
              var parentSubpanel = targetParts.slice(0, 2).join('-');
              panelHistory.push({
                tab: currentTab,
                subpanel: parentSubpanel,
                title: getSubpanelTitle(parentSubpanel),
                label: getTabLabel(currentTab)
              });
              setBackLabel(matchedCard.dataset.title || getSubpanelTitle(targetSubmenu) || getSubpanelTitle(parentSubpanel) || getTabLabel(currentTab));
            } else {
              panelHistory.push({
                tab: currentTab,
                subpanel: null,
                title: getTabLabel(currentTab),
                label: getTabLabel(currentTab)
              });
              setBackLabel(getTabLabel(currentTab));
            }

            tabs.forEach(function(tab) {
              tab.classList.toggle('is-active', tab.dataset.idealDesktopTab === currentTab);
            });
            currentSubpanel = targetSubmenu;
            showSubpanel(targetSubmenu, matchedCard.dataset.title || '');
            return true;
          }

          var activeSubpanel = matchedCard.closest('[data-ideal-desktop-subpanel]');
          if (activeSubpanel) {
            var subpanelId = activeSubpanel.dataset.idealDesktopSubpanel;
            var subpanelParts = subpanelId.split('-');
            currentTab = subpanelParts[0] || currentTab;
            panelHistory = [];

            if (subpanelParts.length > 2) {
              var parentId = subpanelParts.slice(0, 2).join('-');
              panelHistory.push({
                tab: currentTab,
                subpanel: parentId,
                title: getSubpanelTitle(parentId),
                label: getTabLabel(currentTab)
              });
              setBackLabel(activeSubpanel.dataset.title || getSubpanelTitle(subpanelId) || getSubpanelTitle(parentId) || getTabLabel(currentTab));
            } else {
              panelHistory.push({
                tab: currentTab,
                subpanel: null,
                title: getTabLabel(currentTab),
                label: getTabLabel(currentTab)
              });
              setBackLabel(getTabLabel(currentTab));
            }

            tabs.forEach(function(tab) {
              tab.classList.toggle('is-active', tab.dataset.idealDesktopTab === currentTab);
            });
            currentSubpanel = subpanelId;
            showSubpanel(subpanelId, activeSubpanel.dataset.title || '');
            window.requestAnimationFrame(function() {
              matchedCard.scrollIntoView({ block: 'nearest', inline: 'center' });
              updateScrollButtons();
            });
            return true;
          }

          var activePanel = matchedCard.closest('[data-ideal-desktop-panel]');
          if (activePanel) {
            showTab(activePanel.dataset.idealDesktopPanel);
            window.requestAnimationFrame(function() {
              matchedCard.scrollIntoView({ block: 'nearest', inline: 'center' });
              updateScrollButtons();
            });
            return true;
          }

          return false;
        }

        function handleDesktopTabClick(event) {
          var tab = event.currentTarget || event.target.closest('[data-ideal-desktop-tab]');
          if (!tab || tabs.indexOf(tab) === -1) return;

          event.preventDefault();
          event.stopPropagation();

          var tabKey = tab.dataset.idealDesktopTab;
          var canToggleClosed = menu.classList.contains('is-dropdown') && menu.classList.contains('is-open') && currentTab === tabKey && !currentSubpanel;
          if (canToggleClosed) {
            closeDesktopDropdown();
            return;
          }
          setCurrentCard(null);
          activateTab(tabKey);
          openDesktopDropdown();
        }

        tabs.forEach(function(tab) {
          tab.addEventListener('click', handleDesktopTabClick);
        });

        document.addEventListener('click', function(event) {
          var tab = event.target.closest('[data-ideal-desktop-tab]');
          if (!tab || tabs.indexOf(tab) === -1 || event.defaultPrevented) return;
          handleDesktopTabClick(event);
        });

        menu.querySelectorAll('[data-ideal-desktop-submenu]').forEach(function(button) {
          button.addEventListener('click', function() {
            activateSubmenu(button.dataset.idealDesktopSubmenu, button.dataset.title);
          });
        });

        if (back) {
          back.addEventListener('click', function() {
            var previous = panelHistory.pop();
            if (!previous) {
              showTab(currentTab);
              return;
            }
            if (previous.subpanel) {
              currentSubpanel = previous.subpanel;
              setBackLabel(previous.label);
              showSubpanel(previous.subpanel, previous.title);
            } else {
              showTab(previous.tab);
            }
          });
        }

        if (prev) {
          prev.addEventListener('click', function() {
            var activeList = getActiveList();
            if (activeList) activeList.scrollBy({ left: -170, behavior: 'smooth' });
          });
        }

        if (next) {
          next.addEventListener('click', function() {
            var activeList = getActiveList();
            if (activeList) activeList.scrollBy({ left: 170, behavior: 'smooth' });
          });
        }

        window.addEventListener('resize', function() {
          setDesktopMenuMode();
          updateScrollButtons();
        });
        window.addEventListener('scroll', scheduleDesktopMenuMode, { passive: true });
        document.addEventListener('click', function(event) {
          if ((!menu.classList.contains('is-dropdown') && !menu.classList.contains('is-flow')) || !menu.classList.contains('is-open')) return;
          if (menu.contains(event.target)) return;
          if (event.target.closest('[data-ideal-desktop-tab]')) return;
          closeDesktopDropdown();
        });
        placeDesktopMenu();
        if (!restoreFromCurrentUrl()) {
          showTab(currentTab);
          syncActiveList();
        }
        setDesktopMenuMode();
      });
    }

    function initIdealMobileMenu() {
      document.querySelectorAll('[data-ideal-mobile-menu]').forEach(function(menu) {
        if (menu.dataset.initialized) return;
        menu.dataset.initialized = 'true';

        var details = menu.closest('.main-menu__disclosure');
        var title = menu.querySelector('[data-ideal-mobile-title]');
        var back = menu.querySelector('[data-ideal-mobile-back]');
        var close = menu.querySelector('[data-ideal-mobile-close]');
        var tabs = Array.from(menu.querySelectorAll('[data-ideal-mobile-tab]'));
        var panels = Array.from(menu.querySelectorAll('[data-ideal-mobile-panel]'));
        var subpanels = Array.from(menu.querySelectorAll('[data-ideal-mobile-subpanel]'));
        var currentTab = tabs[0] ? tabs[0].dataset.idealMobileTab : 'products';
        var currentSubpanel = null;
        var panelHistory = [];
        var stateKey = 'idealProductsMobileMenuState';

        function normalizePath(url) {
          if (!url) return '';
          var link = document.createElement('a');
          link.href = url;
          return link.pathname.replace(/\/$/, '') || '/';
        }

        function collectionHandleFromUrl(url) {
          var path = normalizePath(url);
          var match = path.match(/^\/collections\/([^\/?#]+)/);
          return match ? decodeURIComponent(match[1]) : '';
        }

        function getItemUrl(item) {
          return item ? (item.dataset.url || item.getAttribute('href') || '') : '';
        }

        function getSubpanelTitle(id) {
          var panel = subpanels.find(function(subpanel) {
            return subpanel.dataset.idealMobileSubpanel === id;
          });
          return panel ? panel.dataset.title || '' : '';
        }

        function getTabLabel(tabKey) {
          var tab = tabs.find(function(tabButton) {
            return tabButton.dataset.idealMobileTab === tabKey;
          });
          return tab ? tab.textContent.trim() : 'Proizvodi';
        }

        function saveMenuState(item) {
          if (!item || currentTab !== 'products') return;
          var activeSubpanel = item.closest('[data-ideal-mobile-subpanel]');
          var activePanel = item.closest('[data-ideal-mobile-panel]');
          var state = {
            tab: currentTab,
            subpanel: activeSubpanel ? activeSubpanel.dataset.idealMobileSubpanel : null,
            title: activeSubpanel ? activeSubpanel.dataset.title || '' : activePanel ? activePanel.dataset.title || '' : getTabLabel(currentTab),
            path: normalizePath(getItemUrl(item))
          };
          try {
            window.sessionStorage.setItem(stateKey, JSON.stringify(state));
          } catch (error) {}
        }

        function resetMenuScroll() {
          var content = menu.closest('.main-menu__content');
          if (content) content.scrollTop = 0;
          menu.scrollTop = 0;
        }

        function syncBodyOpenState() {
          var isOpen = Boolean(details && details.open && details.classList.contains('is-open'));
          document.body.classList.toggle('ideal-mobile-menu-open', isOpen);
          if (isOpen) resetMenuScroll();
        }

        function showTab(tabKey) {
          currentTab = tabKey;
          currentSubpanel = null;
          menu.classList.remove('is-submenu');
          tabs.forEach(function(tab) {
            tab.classList.toggle('is-active', tab.dataset.idealMobileTab === tabKey);
          });
          panels.forEach(function(panel) {
            panel.classList.toggle('is-active', panel.dataset.idealMobilePanel === tabKey);
            if (panel.dataset.idealMobilePanel === tabKey && title) title.textContent = panel.dataset.title || '';
          });
          subpanels.forEach(function(panel) {
            panel.classList.remove('is-active');
          });
          resetMenuScroll();
        }

        function showSubpanel(id, panelTitle) {
          panels.forEach(function(panel) {
            panel.classList.remove('is-active');
          });
          subpanels.forEach(function(panel) {
            panel.classList.toggle('is-active', panel.dataset.idealMobileSubpanel === id);
          });
          if (title) title.textContent = panelTitle || '';
          menu.classList.add('is-submenu');
          resetMenuScroll();
        }

        function activateTab(tabKey) {
          panelHistory = [];
          showTab(tabKey);
        }

        function activateSubmenu(id, panelTitle) {
          panelHistory.push({
            tab: currentTab,
            subpanel: currentSubpanel,
            title: title ? title.textContent : ''
          });
          currentSubpanel = id;
          showSubpanel(id, panelTitle);
        }

        function buildHistoryForSubpanel(subpanelId) {
          var parts = subpanelId ? subpanelId.split('-') : [];
          panelHistory = [];
          if (!parts.length) return;
          currentTab = parts[0] || currentTab;

          if (parts.length > 2) {
            var parentId = parts.slice(0, 2).join('-');
            panelHistory.push({
              tab: currentTab,
              subpanel: parentId,
              title: getSubpanelTitle(parentId) || getTabLabel(currentTab)
            });
          } else {
            panelHistory.push({
              tab: currentTab,
              subpanel: null,
              title: getTabLabel(currentTab)
            });
          }
        }

        function restoreFromItem(item) {
          if (!item) return false;

          var activeSubpanel = item.closest('[data-ideal-mobile-subpanel]');
          if (activeSubpanel) {
            var subpanelId = activeSubpanel.dataset.idealMobileSubpanel;
            buildHistoryForSubpanel(subpanelId);
            currentSubpanel = subpanelId;
            tabs.forEach(function(tab) {
              tab.classList.toggle('is-active', tab.dataset.idealMobileTab === currentTab);
            });
            showSubpanel(subpanelId, activeSubpanel.dataset.title || '');
            return true;
          }

          var activePanel = item.closest('[data-ideal-mobile-panel]');
          if (activePanel) {
            activateTab(activePanel.dataset.idealMobilePanel);
            return true;
          }

          return false;
        }

        function restoreFromCurrentUrl() {
          var currentPath = normalizePath(window.location.href);
          var currentCollectionHandle = collectionHandleFromUrl(window.location.href);
          var items = Array.from(menu.querySelectorAll('.ideal-mobile-menu__item[data-url], .ideal-mobile-menu__item[href]'));

          var matchedItem = items.find(function(item) {
            var itemUrl = getItemUrl(item);
            if (normalizePath(itemUrl) !== currentPath) return false;
            if (currentPath !== '/') return true;
            if (!window.location.hash) return false;

            var link = document.createElement('a');
            link.href = itemUrl;
            return link.hash === window.location.hash;
          });

          if (!matchedItem && currentCollectionHandle) {
            matchedItem = items.find(function(item) {
              return collectionHandleFromUrl(getItemUrl(item)) === currentCollectionHandle;
            });
          }

          if (matchedItem && restoreFromItem(matchedItem)) return true;

          if (currentPath.indexOf('/products/') === -1) return false;

          try {
            var savedState = JSON.parse(window.sessionStorage.getItem(stateKey) || 'null');
            if (!savedState || savedState.tab !== 'products') return false;
            currentTab = savedState.tab;
            if (savedState.subpanel && subpanels.some(function(panel) { return panel.dataset.idealMobileSubpanel === savedState.subpanel; })) {
              buildHistoryForSubpanel(savedState.subpanel);
              currentSubpanel = savedState.subpanel;
              tabs.forEach(function(tab) {
                tab.classList.toggle('is-active', tab.dataset.idealMobileTab === currentTab);
              });
              showSubpanel(savedState.subpanel, savedState.title || getSubpanelTitle(savedState.subpanel));
              return true;
            }
          } catch (error) {}

          return false;
        }

        tabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            activateTab(tab.dataset.idealMobileTab);
          });
        });

        menu.querySelectorAll('[data-ideal-mobile-submenu]').forEach(function(button) {
          button.addEventListener('click', function() {
            activateSubmenu(button.dataset.idealMobileSubmenu, button.dataset.title);
          });
        });

        menu.querySelectorAll('.ideal-mobile-menu__item[href]').forEach(function(link) {
          link.addEventListener('click', function() {
            saveMenuState(link);
          });
        });

        if (back) {
          back.addEventListener('click', function() {
            var previous = panelHistory.pop();
            if (!previous) {
              showTab(currentTab);
              return;
            }
            if (previous.subpanel) {
              currentSubpanel = previous.subpanel;
              showSubpanel(previous.subpanel, previous.title);
            } else {
              showTab(previous.tab);
            }
          });
        }

        if (close && details) {
          close.addEventListener('click', function() {
            details.open = false;
            details.classList.remove('is-open');
            syncBodyOpenState();
            document.body.classList.remove('overflow-hidden');
          });
        }

        if (details && window.MutationObserver) {
          new MutationObserver(function() {
            syncBodyOpenState();
            if (details.open && details.classList.contains('is-open')) {
              restoreFromCurrentUrl();
            }
          }).observe(details, {
            attributes: true,
            attributeFilter: ['open', 'class']
          });
        }

        syncBodyOpenState();
        if (!restoreFromCurrentUrl()) {
          activateTab(currentTab);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initIdealDesktopMenu();
        initIdealMobileMenu();
      });
    } else {
      initIdealDesktopMenu();
      initIdealMobileMenu();
    }
  })();

  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // ===== Custom Mega Menu Slider Logic =====
  (function() {

    // ---- Click-only open/close for Custom Mega Menu ----
    function initCustomMegaMenuClickBehavior() {
      // Find all details elements that contain a custom-slider mega menu
      document.querySelectorAll('.js-mega-nav').forEach(function(details) {
        if (details.querySelector('.mega-nav--custom-slider') && !details.dataset.customSliderClick) {
          details.dataset.customSliderClick = '1';

          const summary = details.querySelector('summary');
          if (!summary) return;

          // Override hover-open: on large screens, keep closed by default
          // and only toggle on click
          const isLarge = () => window.matchMedia(theme.mediaQueries.md).matches;

          summary.addEventListener('click', function(e) {
            if (!isLarge()) return; // mobile: use default behaviour
            e.preventDefault();
            e.stopPropagation();
            const isOpen = details.hasAttribute('open');
            // Close any other custom slider menus first
            document.querySelectorAll('.js-mega-nav[data-custom-slider-click]').forEach(function(d) {
              if (d !== details) d.removeAttribute('open');
            });
            if (isOpen) {
              details.removeAttribute('open');
            } else {
              details.setAttribute('open', '');
              setTimeout(setupSliders, 30);
            }
          });
        }
      });

      // Close all custom slider menus when clicking outside
      if (!document._customSliderOutsideInit) {
        document._customSliderOutsideInit = true;
        document.addEventListener('click', function(e) {
          document.querySelectorAll('.js-mega-nav[data-custom-slider-click][open]').forEach(function(details) {
            if (!details.contains(e.target)) {
              details.removeAttribute('open');
            }
          });
        });
        // Close on Escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') {
            document.querySelectorAll('.js-mega-nav[data-custom-slider-click][open]').forEach(function(details) {
              details.removeAttribute('open');
            });
          }
        });
      }
    }

    // ---- Slider arrow & scrollbar logic ----
    function initCustomMegaSlider(wrapper) {
      const track = wrapper.querySelector('.custom-mega-slider__track');
      const prevBtn = wrapper.querySelector('.custom-mega-slider__arrow--prev');
      const nextBtn = wrapper.querySelector('.custom-mega-slider__arrow--next');
      const scrollbarThumb = wrapper.querySelector('.custom-mega-slider__scrollbar-thumb');
      const scrollbar = wrapper.querySelector('.custom-mega-slider__scrollbar');
      if (!track) return;

      const itemWidth = () => {
        const first = track.querySelector('.custom-mega-slider__item');
        if (!first) return 160;
        const gap = parseFloat(getComputedStyle(track).gap) || 20;
        return first.offsetWidth + gap;
      };

      function updateState() {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
        if (nextBtn) nextBtn.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
        if (scrollbarThumb && scrollbar && maxScroll > 0) {
          const ratio = track.clientWidth / track.scrollWidth;
          const thumbW = Math.max(ratio * scrollbar.offsetWidth, 32);
          const thumbLeft = (track.scrollLeft / maxScroll) * (scrollbar.offsetWidth - thumbW);
          scrollbarThumb.style.width = thumbW + 'px';
          scrollbarThumb.style.left = thumbLeft + 'px';
        } else if (scrollbarThumb) {
          scrollbarThumb.style.width = '100%';
          scrollbarThumb.style.left = '0';
        }
      }

      if (prevBtn && !prevBtn.dataset.sliderEvt) {
        prevBtn.dataset.sliderEvt = '1';
        prevBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          track.scrollBy({ left: -(itemWidth() * 3), behavior: 'smooth' });
        });
      }
      if (nextBtn && !nextBtn.dataset.sliderEvt) {
        nextBtn.dataset.sliderEvt = '1';
        nextBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          track.scrollBy({ left: itemWidth() * 3, behavior: 'smooth' });
        });
      }

      if (!track.dataset.sliderScrollEvt) {
        track.dataset.sliderScrollEvt = '1';
        track.addEventListener('scroll', updateState, { passive: true });
        window.addEventListener('resize', updateState);
      }
      updateState();
    }

    function setupSliders() {
      initCustomMegaMenuClickBehavior();
      document.querySelectorAll('.mega-nav--custom-slider').forEach(function(wrapper) {
        if (!wrapper.dataset.sliderInit) {
          wrapper.dataset.sliderInit = '1';
          initCustomMegaSlider(wrapper);
        } else {
          // Re-run updateState after menu opens to recalculate
          var track = wrapper.querySelector('.custom-mega-slider__track');
          var prevBtn = wrapper.querySelector('.custom-mega-slider__arrow--prev');
          var nextBtn = wrapper.querySelector('.custom-mega-slider__arrow--next');
          var scrollbar = wrapper.querySelector('.custom-mega-slider__scrollbar');
          var scrollbarThumb = wrapper.querySelector('.custom-mega-slider__scrollbar-thumb');
          if (track && scrollbar) {
            var scrollWidth = track.scrollWidth;
            var clientWidth = track.clientWidth;
            var scrollLeft = track.scrollLeft;
            var scrollbarWidth = scrollbar.offsetWidth;
            var maxScroll = scrollWidth - clientWidth;
            if (prevBtn) prevBtn.disabled = scrollLeft <= 1;
            if (nextBtn) nextBtn.disabled = maxScroll <= 1 || scrollLeft >= maxScroll - 1;
            if (scrollbarThumb && maxScroll > 0) {
              var ratio = clientWidth / scrollWidth;
              var thumbW = Math.max(ratio * scrollbarWidth, 32);
              scrollbarThumb.style.width = thumbW + 'px';
              scrollbarThumb.style.left = '0';
            }
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupSliders);
    } else {
      setupSliders();
    }

    // Re-run whenever any details/mega-nav toggles
    document.addEventListener('toggle', function(e) {
      if (e.target && e.target.closest && e.target.closest('.js-mega-nav')) {
        setTimeout(setupSliders, 40);
      }
    }, true);
  })();


  // ===== Custom Mega Menu 02 â€” Tab panel logic =====
  (function() {

    var ACTIVE_CLASS = 'is-active';

    // Shared body overlay
    var bodyOverlay = null;
    function getBodyOverlay() {
      if (!bodyOverlay) {
        bodyOverlay = document.createElement('div');
        bodyOverlay.className = 'cmm02-body-overlay';
        document.body.appendChild(bodyOverlay);
        bodyOverlay.addEventListener('click', function() { closeAllMenus(); });
      }
      return bodyOverlay;
    }

    function activateTab(panel, tabBtn) {
      panel.querySelectorAll('[data-cmm02-tab]').forEach(function(t) {
        t.classList.remove(ACTIVE_CLASS);
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
        var tp = document.getElementById(t.getAttribute('aria-controls'));
        if (tp) { tp.classList.remove(ACTIVE_CLASS); tp.hidden = true; }
      });
      tabBtn.classList.add(ACTIVE_CLASS);
      tabBtn.setAttribute('aria-selected', 'true');
      tabBtn.setAttribute('tabindex', '0');
      var sp = document.getElementById(tabBtn.getAttribute('aria-controls'));
      if (sp) { sp.classList.add(ACTIVE_CLASS); sp.hidden = false; }
    }

    function resetToFirstTab(panel) {
      var first = panel.querySelector('[data-cmm02-tab]');
      if (first) activateTab(panel, first);
    }

    function openMenu(details) {
      // Close any other open CMM02
      document.querySelectorAll('.js-mega-nav[data-cmm02-click][open]').forEach(function(d) {
        if (d !== details) closeMenu(d);
      });
      details.setAttribute('open', '');
      var panel = details.querySelector('[data-cmm02-panel]');
      if (panel) resetToFirstTab(panel);
      getBodyOverlay().classList.add('is-visible');
    }

    function closeMenu(details) {
      details.removeAttribute('open');
      if (bodyOverlay) bodyOverlay.classList.remove('is-visible');
    }

    function closeAllMenus() {
      document.querySelectorAll('.js-mega-nav[data-cmm02-click]').forEach(function(d) {
        closeMenu(d);
      });
    }

    function initCMM02() {
      document.querySelectorAll('.js-mega-nav').forEach(function(details) {
        // Only handle details that contain a cmm02 panel
        if (!details.querySelector('[data-cmm02-panel]')) return;
        if (details.dataset.cmm02Click) return;
        details.dataset.cmm02Click = '1';

        var summary = details.querySelector('summary');
        if (!summary) return;

        var isLarge = function() { return window.matchMedia(theme.mediaQueries.md).matches; };

        // Intercept summary click on desktop
        summary.addEventListener('click', function(e) {
          if (!isLarge()) return; // mobile: let default accordion work
          e.preventDefault();
          e.stopPropagation();
          if (details.hasAttribute('open')) {
            closeMenu(details);
          } else {
            openMenu(details);
          }
        });

        // Also attach tab click events
        var panel = details.querySelector('[data-cmm02-panel]');
        if (panel && !panel.dataset.cmm02TabsInit) {
          panel.dataset.cmm02TabsInit = '1';
          panel.querySelectorAll('[data-cmm02-tab]').forEach(function(tabBtn) {
            tabBtn.addEventListener('click', function(e) {
              e.stopPropagation();
              activateTab(panel, tabBtn);
            });
            tabBtn.addEventListener('keydown', function(e) {
              var tabs = Array.from(panel.querySelectorAll('[data-cmm02-tab]'));
              var idx = tabs.indexOf(tabBtn);
              if (e.key === 'ArrowRight') {
                var next = tabs[(idx + 1) % tabs.length];
                next.focus(); activateTab(panel, next);
              } else if (e.key === 'ArrowLeft') {
                var prev = tabs[(idx - 1 + tabs.length) % tabs.length];
                prev.focus(); activateTab(panel, prev);
              }
            });
          });
        }
      });

      // Global handlers â€” set up once
      if (!document._cmm02GlobalInit) {
        document._cmm02GlobalInit = true;

        // Escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') closeAllMenus();
        });

        // Click outside header closes all
        document.addEventListener('click', function(e) {
          var inHeader = e.target.closest('store-header, .main-menu');
          if (!inHeader) closeAllMenus();
        });

        // Clicking other top-nav items closes all
        document.querySelectorAll('.main-nav > li').forEach(function(li) {
          li.addEventListener('mousedown', function(e) {
            // If the mousedown is NOT inside a cmm02 details, close all
            if (!e.target.closest('[data-cmm02-panel]') && !e.target.closest('[data-cmm02-tab]')) {
              var inCmm02 = e.target.closest('.js-mega-nav[data-cmm02-click]');
              if (!inCmm02) closeAllMenus();
            }
          }, true);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCMM02);
    } else {
      initCMM02();
    }

    // Re-init after any toggle event (theme may re-render nav)
    document.addEventListener('toggle', function(e) {
      if (e.target && e.target.closest && e.target.closest('.js-mega-nav')) {
        setTimeout(initCMM02, 40);
      }
    }, true);

  })();



  } catch(e) { console.error(e); }
})();
})();
